module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-header-columns"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.columns), function(column, key) {
    return _c('div', {
      staticClass: "columns",
      class: {
        shrink: column === ''
      }
    }, [_vm._v(_vm._s(column))])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-515024f6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/HeaderColumns.vue
// module id = 2492
// module chunks = 1